export default {
  common: {
    userSearchNoOptions: 'ei osumaa',
  },
  form: {
    replacementQuestion_sv_primary_written:
      'Oletko kirjoittanut äidinkielen (ruotsi) ylioppilaskokeesta laudaturin tai eximian tai oletko muuten taitava ja itseohjautuva kirjoittaja?',
    replacementQuestion_en_secondary_any:
      'Koen, että olen jo aiemmissa opinnoissani / työelämässä / vapaa-ajalla hankkinut tutkintooni kuuluvia opintoja vastaavat tiedot ja taidot (CEFR B2).',
    replacementQuestion_sv_secondary_any:
      'Koen, että olen jo aiemmissa opinnoissani / työelämässä / vapaa-ajalla hankkinut tutkintooni kuuluvia opintoja vastaavat tiedot ja taidot (CEFR B1).',
    mentoringQuestion_fi_secondary_any:
      'Haluatko harjoitella arkipäivän asioista keskustelua yhdessä muiden kanssa ja kerrata peruskielioppia ennen tutkintoon kuuluvalle finskan kurssille osallistumista?',
    finmuMentoringQuestion_fi_secondary_any:
      'Haluatko harjoitella ajankohtaisista asioista ja opinnoistasi suomeksi puhumista ja kirjoittamista yhdessä muiden opiskelijoiden kanssa?',
    challengeQuestion_fi_secondary_any:
      'Jännitätkö suomen kielen käyttämistä niin paljon, että et voi osallistua kurssille, jossa harjoitellaan kieltä yhdessä muiden kanssa?',
    previoslyDoneLangExplanation:
      '\nTutkinnon pakolliset kieli- ja viestintäopinnot voidaan korvata aiempaan kotimaiseen korkeakoulututkintoon sisältyneillä vastaavilla opinnoilla sekä muilla vastaavilla aiemmilla suorituksilla. \n',
    searchedLanguageExplanation:
      '\nKaikkiin kandidaatin tutkintoihin kuuluu vähintään 10 op pakollisia kieli- ja viestintäopintoja. Opinnot suoritetaan koulusivistyskielesi mukaan seuraavasti:  \n\n  - äidinkieli (suomi/ruotsi) 3 op  \n\n  - Toinen kotimainen kieli (ruotsi/suomi) 3 op \n\n  - Vieras kieli (lähtötaitotaso englannissa CEFR B2, muissa kielissä CEFR B1) 4 op \n',
    primaryLanguageQuestion: 'Mikä on koulusivistyskielesi?',
    languageQuestion: 'Mistä kielestä haet kursseja?',
    primaryLanguageSpecificationQuestion: 'Kumman ensisijaisen kielen tyypin haluat valita?',
    previouslyDoneLangQuestion:
      'Minulla on aiempaan kotimaiseen korkeakoulututkintoon (valmis tai keskeneräinen) suoritettuja vastaavia opintoja tai muita vastaavia suorituksia.',
    studyPeriodQuestion: 'Mikä on haluamasi kurssin suoritusajankohta?',
    replacementQuestion:
      'Koen, että olen jo aiemmissa opinnoissani / työelämässä / vapaa-ajalla hankkinut tutkintooni kuuluvia opintoja vastaavat tiedot ja taidot',
    mentoringQuestion: 'Tarvitsetko harjoitusta ennen kuin suoritat tutkintoon kuuluvan opintojakson?',
    challengeQuestion: 'Minulle kielenoppiminen on erityisen haasteellista ja se jännittää/pelottaa minua paljon',
    graduationQuestion: 'Valmistutko puolen vuoden sisällä?',
    studyPlaceQuestion: 'Mikä opiskelumuoto sopii sinulle parhaiten?',
    integratedQuestion: 'Olen kiinnostonut kurssista, joka on integroitu oman alani opintoihin.',
    independentQuestion: 'Haluan työskennellä itsenäisesti tai autonomisesti.',
    flexibleQuestion: 'Haluan osallistua kurssille, jonka aikataulu on joustava.',
    moocQuestion: 'Haluatko etsiä MOOC-kursseja (Massive Open Online Courses)?',
    collaborationQuestion: 'Näytä yhteistyökumppanien kursseja',
    multiPeriodQuestion: 'Hae kursseja jotka kestävät usean periodin ajan',
    finnish: 'suomi',
    swedish: 'ruotsi',
    english: 'englanti',
    yes: 'Kyllä',
    no: 'Ei',
    yesDefinitely: 'Kyllä (ehdottomasti)',
    noDefinitely: 'Ei (ehdottomasti)',
    neutralChoice: 'En välitä',
    both: 'Molemmat',
    'language-both': 'Kirjoitus- ja puheviestintä',
    written: 'Kirjoitusviestintä',
    spoken: 'Puheviestintä',
    summer: 'Kesä',
    intensivePeriod1: 'Intensiivijakso 1',
    intensivePeriod2: 'Intensiivijakso 2',
    period: 'Periodi',
    periods: 'Periodit',
    mentoringQuestionYes: 'Kaipaisin valmennusta ennen opintojen suoritusta',
    mentoringQuestionNo: 'En koe tarvitsevani harjoitusta',
    graduationQuestionYes: 'Kyllä, puolen vuoden sisällä.',
    graduationQuestionNo: 'En ole valmistumassa puolen vuoden sisällä.',
    studyPlaceRemote: 'Etätapaamisia sisältävä opiskelu.',
    studyPlaceOnline: 'Itsenäinen verkko-opiskelu',
    studyPlaceCombined: 'Etäopiskelu ja lähiopetus',
    studyPlaceF2F: 'Lähitapaamisia sisältävä opiskelu',
    studyPlaceNeutral: 'Opiskelumuodolla ei ole väliä',
    primaryLanguageExplanation:
      '\n Opintojen suorittamiseen vaikuttaa koulusivistyskielesi.  \n\n Lue tarkemmat ohjeet Opiskelu-palvelun sivulta\n [Mikä on koulusivistyskielesi?](https://studies.helsinki.fi/ohjeet/artikkeli/mika-koulusivistyskieleni) \n\n',
    replacementQuestion_fi_primary_written:
      'Oletko kirjoittanut äidinkielen (suomi) (tai S2:n) ylioppilaskokeesta laudaturin tai eximian tai oletko muuten taitava ja itseohjautuva kirjoittaja?',
    replacementQuestion_fi_secondary_any:
      'Oletko kaksikielinen (suomi – ruotsi) tai käytätkö suomea paljon ja sujuvasti opinnoissasi ja/tai muussa elämässäsi?',
    challengeQuestion_fi_primary_written:
      'Onko sinun elämäntilanteesi tai jännittämisen vuoksi vaikea osallistua läsnäoloa tai yhteisiä verkkotapaamisia sisältäville toteutuksille?',
    challengeQuestion_fi_primary_spoken:
      'Sosiaaliset tilanteet ovat minusta pelottavia ja jännitän vahvasti erilaisissa vuorovaikutustilanteissa.',
    points: 'tarkkuus',
  },
  question: {
    extrainfo: 'Lisätietoa',
    checkInstructionsCrediting:
      'Lue tarkemmat ohjeet Opiskelu-palvelun sivulta [Tutkinnon viestinnän ja kieliosaamisen opintojen hyväksilukeminen ja hae opintojen korvaamista Sisussa](https://studies.helsinki.fi/ohjeet/artikkeli/opintojen-ja-osaamisen-hyvaksilukeminen?check_logged_in=1)',
    fromHere: 'täältä',
    noExtrainfo: 'Ei lisätietoa',
    noOrganisation: 'Tiedekuntaa ei löytynyt',
    pickStudy: 'Valitse tiedekunta',
    skipped: 'Kysymys ohitettu: ei vaikutusta',
    mandatory: 'Pakollinen',
    close: 'Sulje',
  },
  app: {
    logout: 'Kirjaudu ulos',
    questionaire: 'Kysely',
    recommendations: 'Suositukset',
    send: 'Lähetä',
    back: 'Takaisin',
  },
  recommendations: {
    accurate: 'Tarkimmat suositukset:',
    all: 'Kaikki suositukset (tarkuus voi vaihdella):',
    pointbased: 'Pistepohjaiset suositukset',
  },
  v2: {
    periodFilter: {
      title: 'Periodi',
    },
    retakeQuestions: 'Vastaa alkukysymyksiin',
    openFilters: 'Avaa suodattimet',
    closeFilters: 'Sulje suodattimet',
    opensInNewWindow: 'aukeaa uudessa ikkunassa',
    moreOptions: 'Lisää vaihtoehtoja',
    filtersRegion: 'Kurssisuodattimet',
    appDescription:
      'Polku on Helsingin yliopiston kielikeskuksen kurssisuosittelija. Se ehdottaa sinulle opintoihisi sopivia kieli- ja viestintäkursseja. Aloita vastaamalla alkukysymyksiin opinto-oikeudestasi ja koulusivistyskielestäsi, ja rajaa sen jälkeen ehdotuksia Kurssisuodattimet-navigaatiossa olevilla kysymyksillä. Ehdotukset päivittyvät heti kun muutat vastausta, ja osuvien kurssien määrä kerrotaan Kurssisuositukset-alueella.',
    filter: {
      noMatches: 'ei osuvia kursseja',
      matchCount_one: '{{count}} osuva kurssi',
      matchCount_other: '{{count}} osuvaa kurssia',
      removeSelection: 'Poista valinta {{selection}}',
      mandatoryStaysOpen: 'Pysyy avoinna, kunnes vastaat tähän pakolliseen kysymykseen',
    },
    languageSelector: 'Kieli',
    universityLogoAlt: 'Helsingin yliopisto',
    modal: {
      close: 'Sulje',
      warning: 'Varoitus',
    },
    skipQuestions: 'Ohita kysymykset',
    done: 'Valmis',
    welcomeText: 'Vastaa ensin muutamaan alkukysymykseen. Voit muokata näitä myöhemmin.',
    results: {
      heading: 'Kurssisuositukset',
      loading: 'Ladataan kurssisuosituksia',
      loadingFilters: 'Ladataan suodattimia',
      unansweredMandatory_one: 'Vastaa vielä seuraavaan pakolliseen kysymykseen: {{question}}',
      unansweredMandatory_other: 'Vastaa vielä {{count}} pakolliseen kysymykseen, seuraava: {{question}}',
      count_one: '{{count}} kurssi löytyi',
      count_other: '{{count}} kurssia löytyi',
    },
    noRecommendations: {
      title: 'Kursseja ei löytynyt',
      unansweredMandatory: 'Vastaa vielä pakolliseen kysymykseen',
      openFilterQuestion: 'Avaa suodattimet: {{question}}',
      changeSelectionsButton: 'Muuta valintojasi',
      resetButton: 'Tyhjennä valinnat',
      resetConfirmationTitle: 'Tyhjennetäänkö valinnat?',
      resetConfirmationDescription: 'Tämä tyhjentää nykyiset vastauksesi ja palauttaa oletussuodattimet.',
      resetConfirmationCancel: 'Peruuta',
      resetConfirmationConfirm: 'Tyhjennä valinnat',
    },
    appTitle: 'Polku',
    adminButton: 'ADMIN',
    courseTags: {
      title: 'Kurssitagit',
      course: 'Kurssi',
      matched: '{{count}} kurssia vastaa nykyistä hakua',
      columns: 'Tagisarakkeet ({{shown}}/{{total}})',
      columnsAll: 'Kaikki',
      columnsStudy: 'Opintotagit',
      columnsFaculty: 'Tiedekuntatagit',
      cancel: 'Peruuta',
      close: 'Sulje',
      state: {
        inherited: 'peritty opintojaksolta',
        customCodeUrn: 'Sisun custom code urn -tagi',
        added: 'lisätty tälle toteutukselle',
        both: 'sekä apparaatissa että Sisussa',
        ignored: 'ohitettu tällä toteutuksella',
        unset: 'ei asetettu',
      },
      editing: {
        label: 'Muokattavana',
        new: 'Uusi versio',
        newTitle: 'Luo uusi versio',
        newConfirm: 'Luo versio',
        published: 'Käytössä oleva versio (vain luku)',
        readOnly: 'Käytössä olevaa versiota ei voi muokata. Valitse tai luo versio muokataksesi tageja.',
        editingVersion: 'Muokataan versiota ”{{name}}”. Muutokset tallentuvat siihen heti.',
      },
      publish: {
        liveVersion: 'Käytössä on versio ”{{name}}”.',
        liveUnknown: 'Käytössä olevaa tagitystä ei ole tallennettu versioksi.',
        publishVersion: 'Tarkista ja ota käyttöön',
        reviewTitle: 'Tarkista muutokset ennen käyttöönottoa',
        confirmApply: 'Ota muutokset käyttöön',
        nameLabel: 'Version nimi',
        nameHelp: 'Tyhjänä versio nimetään luontiajan mukaan.',
        descriptionLabel: 'Kuvaus (valinnainen)',
        descriptionHelp: 'Kuvaus tallennetaan version tietoihin.',
      },
      tabs: {
        realisations: 'Toteutukset',
        courseUnits: 'Opintojaksot',
        vocabulary: 'Tagit',
        snapshots: 'Versiot',
      },
      bulk: {
        open: 'Massalisää tageja',
        title: 'Lisää tagit kaikkiin hakua vastaaviin kursseihin',
        tags: 'Tagit',
        tagsHint: 'Kirjoita suodattaaksesi, Enter valitsee korostetun tagin',
        mode: {
          add: {
            label: 'Lisää',
            description: 'Antaa tagin kaikille hakua vastaaville kursseille.',
          },
          ignore: {
            label: 'Ohita',
            description:
              'Merkitsee tagin ohitetuksi kaikilla hakua vastaavilla kursseilla, jolloin opintojaksolta peritty tagi ei enää päde niihin.',
          },
          clear: {
            label: 'Tyhjennä',
            description:
              'Poistaa toteutuksen oman lisäys- tai ohitusasetuksen, jolloin tagi määräytyy taas opintojakson mukaan.',
          },
        },
        newTagNote: 'Vain olemassa olevia tageja voi lisätä. Luo uusi tagi ensin Tagit-välilehdellä.',
        explanation: 'Tämä koskee kaikkia hakua vastaavia kursseja, ei vain näkyvää sivua.',
        previewPending: 'Valitse vähintään yksi tagi nähdäksesi montako kurssia muuttuisi.',
        previewCount: '{{count}} kurssia vastaa hakua.',
        confirm: 'Lisää kaikkiin {{count}} kurssiin',
      },
      cu: {
        explanation:
          'Tässä asetetut tagit periytyvät opintojakson kaikille toteutuksille. Toteutus voi ohittaa perityn tagin.',
        courseCode: 'Kurssikoodi',
        courseUnit: 'Opintojakso',
        realisations: 'Toteutuksia',
        matched: '{{count}} opintojaksoa nykyisessä haussa',
      },
      vocabulary: {
        key: 'Avain',
        description: 'Kuvaus',
        add: 'Lisää tagi',
        delete: 'Poista',
        deleteConfirm: 'Poistetaanko tagi {{key}}? Myös kaikki sen opintojakso- ja toteutusliitokset poistetaan.',
        duplicate: 'Tämä avain on jo käytössä.',
        invalid: 'Virheellinen tagiavain.',
      },
      snapshots: {
        name: 'Version nimi',
        description: 'Kuvaus',
        createdAt: 'Tallennettu',
        save: 'Tallenna versio',
        compare: 'Vertaa',
        edit: 'Muokkaa',
        editTaggingConfirm: 'Avataanko versio {{name}} muokattavaksi? Nykyinen luonnos korvataan sen sisällöllä.',
        activate: 'Ota käyttöön',
        activeShort: 'Käytössä',
        activeIs: 'Käytössä: {{name}}',
        activeUnknown: 'Käytössä: tagitys, jota ei ole tallennettu versioksi',
        activateConfirm:
          'Otetaanko versio {{name}} käyttöön? Se korvaa nykyisen tagituksen ja menee heti suositteluun.',
        restore: 'Palauta',
        delete: 'Poista',
        empty: 'Ei tallennettuja versioita.',
        restoreConfirm: 'Palautetaanko tagitus {{name}}? Nykytila tallennetaan ensin versioksi.',
        deleteConfirm: 'Poistetaanko tämä versio?',
        export: 'Vie',
        import: 'Tuo',
        exportFailed: 'Vienti epäonnistui',
        importFailed: 'Tuonti epäonnistui',
        importConfirm: 'Tuodaanko {{fileName}}? Tämä korvaa kaikki nykyiset tagitukset.',
        diffTitle: 'Erot nykyiseen tagitukseen',
        diffUnchanged: 'Nykyinen tagitus on identtinen tämän version kanssa.',
        diffVocabularyChanges: 'Muutokset tagivalikoimaan',
        diffCourseChanges: 'Muutokset kurssien tageihin',
        diffRealisationChanges: 'Muutokset yksittäisten toteutusten tageihin',
        diffBefore: 'Ennen: {{tags}}',
        diffNoTags: 'ei tageja',
        diffUnknownCourse: 'Kurssia ei löytynyt',
        diffLoading: 'Ladataan kurssien nimiä...',
      },
    },
    adminNav: {
      back: 'Takaisin',
      backToApp: 'Takaisin palveluun',
      overview: 'Asetukset',
      courses: 'Kurssit',
      stats: 'Tilastot',
      feedback: 'Käyttäjäpalaute',
      loginAs: 'Kirjaudu toisena',
      updater: 'Päivittäjä',
      courseTags: 'Kurssitagit',
      errorTest: 'Virhetesti',
    },
    admin: {
      loading: 'Ladataan...',
      settingsTabs: {
        texts: 'Teksti asetukset',
        filters: 'Filtteri asetukset',
        codes: 'Koodit',
        languages: 'Kielikategoriat',
      },
      recommendationCodes: {
        title: 'Suositeltavat kurssikoodit',
        intro:
          'Kurssikoodit joita suositellaan tiedekunnan ja kielivalintojen perusteella. Kurssi näkyy suosituksissa vasta kun sen toteutus on merkitty Sisussa tiedekunnan kk-apparaatti-tunnisteella.',
        loading: 'Ladataan...',
        newCode: 'Lisää koodi',
        editCode: 'Muokkaa koodia',
        organisation: 'Tiedekunta',
        language: 'Kieli',
        courseCode: 'Kurssikoodi',
        courseCodeHelp: 'Esimerkiksi KK-ENERI. Sallitut merkit: kirjaimet, numerot, viiva, kauttaviiva ja piste.',
        search: 'Hae kurssikoodia',
        matrixIntro:
          'Yksi rivi per kurssikoodi. Rasti tarkoittaa, että koodi suositellaan kyseiselle tiedekunnalle. Klikkaus lisää tai poistaa koodin heti, ja saman ruudun klikkaus uudelleen palauttaa tilanteen.',
        coverage: '{{count}} / {{total}}',
        coverageHeader: 'Tiedekuntia',
        toggleCell: '{{courseCode}} — {{faculty}}',
        allValues: 'Kaikki',
        anyValue: 'Kaikki',
        save: 'Tallenna',
        cancel: 'Peruuta',
        saveFailed: 'Tallennus epäonnistui',
        export: 'Vie tiedostoon',
        exportFailed: 'Vienti epäonnistui',
        import: 'Tuo tiedostosta',
        importConfirm: 'Tuodaanko koodit tiedostosta {{fileName}}?',
        importFailed: 'Tuonti epäonnistui',
        importCompleted: 'Tuotiin {{count}} koodia',
        parseFailed: 'Tiedoston lukeminen epäonnistui',
        languagesTitle: 'Kielikategoriat',
        languagesIntro:
          'Kielikategoria kertoo mihin kielivalintoihin sen kurssikoodit sopivat. Nimi on vain näyttöä varten, suositukset perustuvat kieleen, tyyppiin ja tarkenteeseen.',
        languageIntro:
          'Nimi näytetään vain käyttöliittymässä. Kieli, tyyppi ja tarkenne määrittävät milloin kategorian kurssikoodit suositellaan.',
        languageName: 'Nimi',
        newLanguage: 'Lisää kielikategoria',
        editLanguage: 'Muokkaa kielikategoriaa',
        deleteLanguage: 'Poista kielikategoria',
        confirmDeleteLanguage: 'Poistetaanko kielikategoria {{name}}?',
        lang: 'Kieli',
        languageType: 'Tyyppi',
        specification: 'Tarkenne',
        langOption: {
          fi: 'Suomi',
          sv: 'Ruotsi',
          en: 'Englanti',
        },
        languageTypeOption: {
          primary: 'Äidinkieli',
          secondary: 'Toinen kotimainen',
        },
        specificationOption: {
          spoken: 'Puheviestintä',
          written: 'Kirjoitusviestintä',
        },
        table: {
          actions: 'Toiminnot',
          codeCount: 'Koodeja',
        },
      },
      errorTest: {
        pageTitle: 'Virhetesti',
        description:
          'Aiheuta tahallinen virhe ja varmista, että virheraportointi toimii. Virheet lähetetään Sentryyn vain tuotannossa.',
        backendOk: 'Palvelin vastasi onnistuneesti — virhettä ei aiheutettu.',
        backendTriggered: 'Palvelinvirhe aiheutettu (tila {{status}}).',
        frontendTriggered: 'Selainvirhe aiheutettu.',
        causeBackend: 'Aiheuta virhe palvelimella',
        causeFrontend: 'Aiheuta virhe selaimessa',
      },
      courses: {
        pageTitle: 'KK-kurssit',
        total: 'Näytetään vain toteutukset, joiden kurssikoodi alkaa KK-. Yhteensä: {{total}}',
        loading: 'Ladataan kursseja...',
        visit: 'Avaa',
        table: {
          name: 'Kurssin nimi',
          codes: 'Kurssikoodit',
          customUrns: 'Mukautetut URN:t',
          dates: 'Päivämäärät',
          review: 'Tarkistus',
          reviewUpdated: 'Tarkistus päivitetty',
          actions: 'Toiminnot',
        },
        search: {
          nameLegend: 'Nimi',
          nameField: 'Haku',
          urnLegend: 'URN',
          includeLegend: 'Sisällytä',
          excludeLegend: 'Poissulje',
          urnsToInclude: 'Sisällytettävät URN:t',
          urnsToExclude: 'Poissuljettavat URN:t',
          includeOrTitle: 'Näytä kurssit, jotka vastaavat mitä tahansa vasemmalla listatuista URN:eistä',
          includeAndTitle: 'Näytä vain kurssit, jotka vastaavat kaikkia vasemmalla listattuja URN:eitä',
          excludeOrTitle: 'Poista kurssit, jotka vastaavat mitä tahansa vasemmalla listatuista URN:eistä',
          excludeAndTitle: 'Poista vain kurssit, jotka vastaavat kaikkia vasemmalla listattuja URN:eitä',
          tagLegend: 'Tagit',
          tagsToInclude: 'Sisällytettävät tagit',
          tagsToExclude: 'Poissuljettavat tagit',
          tagIncludeOrTitle: 'Näytä kurssit, joilla on mikä tahansa vasemmalla listatuista tageista',
          tagIncludeAndTitle: 'Näytä vain kurssit, joilla on kaikki vasemmalla listatut tagit',
          tagExcludeOrTitle: 'Poista kurssit, joilla on mikä tahansa vasemmalla listatuista tageista',
          tagExcludeAndTitle: 'Poista vain kurssit, joilla on kaikki vasemmalla listatut tagit',
          courseCodeLegend: 'Kurssikoodi',
          courseCodeInclude: 'Sisällytä',
          courseCodeExclude: 'Poissulje (pilkulla eroteltuna)',
          reviewLegend: 'Tarkistus',
          statusField: 'Tila',
          statusAll: 'Kaikki',
          statusReviewed: 'Tarkistettu',
          statusNotReviewed: 'Ei tarkistettu',
          courseDateLegend: 'Kurssin ajankohta',
          courseDateTooltip: 'Näyttää vain kurssit, jotka sekä alkavat että päättyvät valitulla aikavälillä',
          from: 'Alkaen',
          to: 'Päättyen',
          submit: 'Hae',
        },
      },
      review: {
        reviewed: 'Tarkistettu',
        notReviewed: 'Ei tarkistettu',
        commentPlaceholder: 'Lisää kommentti',
        saved: 'Tarkistus tallennettu',
        saveButton: 'Tallenna tarkistus',
        saveFailed: 'Tarkistuksen tallentaminen epäonnistui',
      },
      stats: {
        pageTitle: 'Käyttötilastot',
        legendHint: 'Piilota organisaatio klikkaamalla selitettä, palkkia tai sektoria.',
        hideAll: 'Piilota kaikki',
        showAll: 'Näytä kaikki',
        start: 'Alkaen',
        end: 'Päättyen',
        groupBy: 'Ryhmittely',
        hour: 'Tunti',
        day: 'Päivä',
        month: 'Kuukausi',
        year: 'Vuosi',
        last14Days: 'Viimeiset 14 päivää',
        exportCsv: 'Lataa CSV',
        csv: {
          period: 'Aikaväli',
          faculty: 'Tiedekunta',
          phase1: 'Kandiohjelma',
          phase2: 'Maisteriohjelma',
          count: 'Käyttäjiä',
        },
        uniqueUsers: 'Uniikit käyttäjät',
        faculty: 'Tiedekunta',
        loading: 'Ladataan tilastoja...',
        noVisits: 'Ei käyntejä valitulla aikavälillä.',
        programmes: {
          title: 'Koulutusohjelma',
          phase1: 'Kandiohjelma',
          phase2: 'Maisteriohjelma',
          unknown: 'Ei tiedossa',
          noData: 'Ei koulutusohjelmatietoja valitulla aikavälillä.',
        },
      },
      backendLocales: {
        loading: 'Ladataan tekstejä...',
        title: 'Palvelimelta tulevat tekstit',
        intro:
          'Tekstit, jotka voivat vaihdella tiedekunnan ja kielivalintojen mukaan. Jokaisella avaimella tulisi olla yleisteksti, jotta kaikille käyttäjille näytetään jotain.',
        table: {
          key: 'Avain',
          description: 'Kuvaus',
          textCount: 'Tekstejä',
          textFi: 'Teksti (fi)',
          actions: 'Toiminnot',
        },
        anyValue: 'mikä tahansa',
        organisation: 'Tiedekunta',
        lang: 'Haettavan kurssin kieli',
        primaryLanguage: 'Koulusivistyskieli',
        specification: 'Suoritustapa',
        langOption: {
          fi: 'suomi',
          sv: 'ruotsi',
          en: 'englanti',
        },
        specificationOption: {
          writtenAndSpoken: 'kirjallinen ja suullinen',
          written: 'kirjallinen',
          spoken: 'suullinen',
        },
        specificationHelp:
          'Suoritustapa kysytään käyttäjältä vain, kun haettavan kurssin kieli on sama kuin koulusivistyskieli.',
        specificationUnreachable:
          'Näillä kielivalinnoilla suoritustapaa ei kysytä käyttäjältä, joten se on pakotettu arvoon "mikä tahansa".',
        newKey: 'Uusi avain',
        editKey: 'Muokkaa avainta',
        deleteKey: 'Poista avain',
        keyLabel: 'Avain',
        keyHelp: 'Koodissa käytettävä tunniste, esimerkiksi noRecommendations.additionalInfo',
        descriptionLabel: 'Kuvaus',
        descriptionHelp: 'Kerro, missä tämä teksti näkyy käyttäjälle. Kirjoita omalla kielelläsi.',
        newText: 'Uusi teksti',
        editText: 'Muokkaa tekstiä',
        deleteText: 'Poista teksti',
        textLabel: 'Teksti (markdown)',
        textToShow: 'Näytettävä teksti',
        whenShown: 'Milloin teksti näytetään',
        preview: 'Esikatselu',
        toggleTexts: 'Näytä avaimen {{key}} tekstit',
        noCatchAll: 'ei yleistekstiä, osa käyttäjistä ei näe mitään',
        save: 'Tallenna',
        cancel: 'Peruuta',
        saveFailed: 'Tallennus epäonnistui',
        confirmDeleteKey:
          'Poistetaanko avain {{key}} ja sen {{count}} tekstiä? Koodi, joka käyttää avainta, alkaa kirjata virhettä.',
        confirmDeleteValue: 'Poistetaanko tämä teksti?',
        export: 'Vie JSON',
        import: 'Tuo JSON',
        exportFailed: 'Vienti epäonnistui',
        importConfirm: 'Tuodaanko tiedosto {{fileName}}? Olemassa olevat tekstit päivitetään.',
        importFailed: 'Tuonti epäonnistui',
        importCompleted: 'Tuonti valmis: {{count}} avainta käsitelty.',
        parseFailed: 'Tiedoston lukeminen epäonnistui',
      },
      filterConfig: {
        loading: 'Ladataan suodattimia...',
        title: 'Suodattimien asetukset',
        table: {
          order: 'Järjestys',
          id: 'ID',
          shortNameFi: 'Lyhyt nimi (fi)',
          enabled: 'Käytössä',
          actions: 'Toiminnot',
        },
        edit: 'Muokkaa',
        restore: 'Palauta',
        restoring: 'Palautetaan...',
        addFilter: '+ Lisää suodatin',
        export: 'Vie asetukset',
        import: 'Tuo asetukset',
        restoreConfirm: 'Palautetaanko suodatin oletusarvoihin? Tämä korvaa nykyiset asetukset.',
        noSeedDefaults: 'Tälle suodattimelle ei ole oletusarvoja palautettavaksi',
        restoreFailed: 'Suodattimen oletusarvojen palauttaminen epäonnistui',
        exportFailed: 'Suodatinasetusten vieminen epäonnistui',
        importConfirm:
          'Tuodaanko suodatinasetukset tiedostosta {{fileName}}?\n\nTämä päivittää olemassa olevat suodattimet tuoduilla asetuksilla.',
        importFailed: 'Suodatinasetusten tuominen epäonnistui',
        importCompleted:
          'Tuonti valmis:\n{{updated}} suodatinta päivitetty\n{{skipped}} suodatinta ohitettu\n{{errors}} virhettä',
        parseFailed: 'Tiedoston lukeminen tai tuominen epäonnistui',
      },
      filterEdit: {
        createTitle: 'Luo suodatin',
        editTitle: 'Muokkaa: {{id}}',
        tabGeneral: 'Yleiset',
        tabVariants: 'Variantit ({{amount}})',
        cancel: 'Peruuta',
        save: 'Tallenna',
        unknownError: 'Tuntematon virhe',
        networkError: 'Verkkovirhe',
        id: 'ID',
        idHelper: 'Pieniä kirjaimia, numeroita ja väliviivoja',
        displayType: 'Näyttötyyppi',
        displayTypeNone: '— ei mitään —',
        displayOrder: 'Järjestysnumero',
        parentFilterId: 'Yläsuodattimen ID (valinnainen)',
        mandatory: 'Pakollinen',
        showInWelcomeModal: 'Näytä aloitusikkunassa',
        hideInCurrentFiltersDisplay: 'Piilota nykyisistä valinnoista',
        hideInFilterSidebar: 'Piilota sivupalkista',
        enabled: 'Käytössä',
        shortName: 'Lyhyt nimi',
        explanation: 'Selitys (valinnainen)',
        explanationHint: '(kysymysmerkki-kuvake)',
        extraInfo: 'Lisätiedot (valinnainen)',
        extraInfoHint: '(näytetään, kun näyttötyyppi on info-only)',
        language: 'Kieli',
        langFi: 'Suomi',
        langSv: 'Ruotsi',
        langEn: 'Englanti',
        optionId: 'Vaihtoehdon ID',
        valueOverride: 'Arvon korvaus',
        selectedByDefault: 'Valittu oletuksena',
        nullValue: '— null —',
        optionName: 'Nimi',
        variantName: 'Variantin nimi',
        variantFallback: 'Variantti {{number}}',
        skipped: 'Ohitettu',
        questionText: 'Kysymysteksti',
        explanationOverride: 'Selityksen korvaus (valinnainen)',
        explanationOverrideField: 'Selityksen korvaus',
        options: 'Vaihtoehdot ({{amount}})',
        addOption: 'Lisää vaihtoehto',
        addVariant: 'Lisää variantti',
      },
    },
    updater: {
      pageTitle: 'Päivittäjä',
      runButton: 'Käynnistä päivitys',
      coursesRunButton: 'Päivitä kurssit',
      coursesConfirmBody: 'Tämä päivittää vain kurssitiedot. Päivittäjän muut vaiheet ohitetaan.',
      alreadyRunning: 'Päivitys on jo käynnissä.',
      confirmTitle: 'Käynnistetäänkö päivitys?',
      confirmBody:
        'Tämä käynnistää kaikkien kurssi-, käyttäjä- ja organisaatiotietojen täyden uudelleensynkronoinnin importerista. Toiminto suoritetaan taustalla ja voi kestää useita minuutteja.',
      confirmButton: 'Käynnistä',
      cancelButton: 'Peruuta',
      runStarted: 'Päivitys käynnistetty.',
      runFailed: 'Päivityksen käynnistäminen epäonnistui.',
      historyTitle: 'Ajohistoria',
      loading: 'Ladataan...',
      empty: 'Ei tallennettuja ajoja.',
      table: {
        id: 'ID',
        status: 'Tila',
        runtype: 'Ajon tyyppi',
        triggeredBy: 'Käynnistäjä',
        started: 'Aloitettu',
        finished: 'Valmistunut',
        duration: 'Kesto',
        error: 'Virhe',
      },
      status: {
        running: 'Käynnissä',
        success: 'Valmis',
        failed: 'Epäonnistui',
      },
    },
    feedback: {
      openButton: 'Anna palautetta',
      title: 'Anna palautetta',
      description: 'Kerro, miten voimme parantaa palvelua.',
      textLabel: 'Palaute',
      starsLabel: 'Tähdet',
      starsValue_one: '{{count}} tähti',
      starsValue_other: '{{count}} tähteä',
      starsEmpty: 'Ei arviota',
      sendMetadata: 'Lähetä hakutiedot',
      sendMetadataInfo:
        'valitsemalla tämän lähetät lomakkeen mukana filtterivalintasi ja saamasi hakutulokset, palaute on silti anonyymi',
      viewMetadata: 'Näytä hakutiedot',
      metadataDialogTitle: 'Hakutietojen esikatselu',
      metadataDialogDescription: 'Tässä näkyvät hakutiedot, jotka voidaan lähettää palautteen mukana.',
      send: 'Lähetä palaute',
      cancel: 'Peruuta',
      sent: 'Palaute lähetetty',
      failed: 'Palautteen lähetys epäonnistui',
      sendContactEmail: 'Lähetä yhteystiedot',
      sendContactEmailInfo:
        'Tämä liittää helsinki.fi-sähköpostiosoitteesi palautteeseen. Valitse tämä, jos haluat meidän voivan vastata palautteeseen. Palaute ei ole anonyymi, jos valitset tämän vaihtoehdon.',
      attachedEmail: 'Liitetty sähköposti: {{email}}',
      admin: {
        backToAdmin: 'Takaisin ylläpitoon',
        pageTitle: 'Käyttäjäpalaute',
        start: 'Alku',
        end: 'Loppu',
        last12Months: 'Viimeiset 12 kuukautta',
        loading: 'Ladataan palautteita...',
        empty: 'Palautteita ei ole vielä lähetetty.',
        readComment: 'Lue',
        dialogTitle: 'Palautekommentti',
        close: 'Sulje',
        starsValue: '{{stars}} / 5 tähteä',
        emailFilterLabel: 'Yhteyssähköposti',
        emailFilterAll: 'Kaikki',
        emailFilterHas: 'Sähköposti liitetty',
        emailFilterNo: 'Ei sähköpostia',
        emailSearchLabel: 'Hae sähköpostilla',
        table: {
          date: 'Päivämäärä',
          stars: 'Tähdet',
          version: 'Versio',
          email: 'Sähköposti',
          text: 'Palaute',
          metadata: 'Metatiedot',
          hasMetadata: 'Kyllä',
          noMetadata: 'Ei',
          action: 'Toiminto',
        },
        metadata: {
          title: 'Suositusmetatiedot',
          filterSelections: 'Filtterin valinnat',
          unnamedCourse: 'Nimetön kurssi',
          recommendations: 'Suositukset',
          points: 'Pisteet',
          courseCodes: 'Kurssikoodit',
          period: 'Ajanjakso',
        },
        massAction: 'Massatoiminto',
        deleteOlderThanPreview: 'Poistaa {{count}} palautetta',
        deleteSelected: 'Poista valitut ({{count}})',
        deleteOlderThanLabel: 'Poista palautteita vanhempia kuin',
        prefill180Days: '180 päivää sitten',
        deleteOlderThanButton: 'Poista',
        confirmDeleteTitle: 'Vahvista poisto',
        confirmDeleteBody: 'Tämä poistaa pysyvästi {{count}} palautetta. Toimintoa ei voi peruuttaa.',
        confirmDeleteButton: 'Poista',
        deleteSuccess: 'Poistettu {{count}} palautetta',
        deleteError: 'Palautteiden poistaminen epäonnistui',
      },
    },
    loginPrompt: 'Ole hyvä ja kirjaudu sisään:',
    loginLink: 'täältä',
    loadingFilters: 'Ladataan suodattimia...',
    sortBy: 'Järjestä',
    sortRecommended: 'Oletus',
    sortName: 'Nimi',
    sortDate: 'Päivämäärä',
    sortPeriod: 'Periodi',
    recommendationSearch: {
      label: 'Hae kursseja nimellä',
      placeholder: 'Kirjoita kurssin nimi',
      resultsCount: 'Näytetään {{shown}} / {{total}} kurssia',
      noMatchesTitle: 'Hakua vastaavia kursseja ei löytynyt',
      noMatchesDescription: 'Kokeile toista kurssin nimeä tai tyhjennä haku nähdäksesi kaikki suositellut kurssit.',
      clearButton: 'Tyhjennä haku',
    },
  },
  course: {
    show: 'Kurssisivu',
    showCourse: 'Kurssisivu: {{course}}',
    credits: 'op',
    reasons: 'perusteet',
    periodName: 'periodi',
    examWeek: 'Tenttiviikko',
    intensivePeriod: 'Intensiivijakso',
  },
  opintotarjonta: {
    mooc: 'mooc',
  },
  loginAsPage: {
    title: 'kayttajahaku',
    userHeader: 'käyttäjä',
  },
  filter: {
    period: 'Periodi',
    periods: 'Periodit',
    organisation: 'Organisaatio',
    language: 'Kieli',
    graduation: 'Valmistuminen puolen vuoden sisällä',
    mentoring: 'Tarvitsetko harjoitusta ennen kurssia',
    integrated: 'Kiinnostunut integroidusta kurssista',
    studyPlace: 'Opiskelupaikka',
    replacement: 'Aiemmin hankittu osaaminen',
    challenge: 'Kielen oppiminen haastavaa',
    independent: 'Haluan työskennellä itsenäisesti',
    flexible: 'Haluan joustavan aikataulun',
    mooc: 'Etsi MOOC-kursseja',
    finmu: 'FinMU liittyvä',
    multiPeriod: 'Kurssin pituus',
    allSelected: 'Kaikki',
  },
  filterShortName: {
    'Opinto-oikeus': 'Opinto-oikeus',
    Koulukieli: 'Koulukieli',
    Kurssi: 'Kurssi',
    Viestintä: 'Viestintä',
    Aikaisemmatopinnot: 'Aikaisemmat opinnot',
    Korvaava: 'Korvaava',
    Valmentava: 'Valmentava',
    Finmu: 'Finmu',
    Edistynyt: 'Mukautettu',
    Valmistuville: 'Valmistuville',
    Integroitu: 'Integroitu',
    Itsenäinen: 'Itsenäinen',
    Opetusmuoto: 'Opetusmuoto',
    Lukuvuosi: 'Lukuvuosi',
    Periodi: 'Periodi',
    MOOC: 'MOOC',
    'opintotarjonta:mooc': 'mooc',
    Yhteistyo: 'Yhteistyö',
    Kurssinpituus: 'Kurssin pituus',
    Exam: 'Tentti',
  },
}
